import React, { useState, useEffect } from "react";

export default function GestionMenus() {
  const [listaModulosBD, setListaModulosBD] = useState([]);
  const [listaSubMenus, setListaSubMenus] = useState([]);
  const [nuevoSubMenu, setNuevoSubMenu] = useState({ modulo_id: "", nombre: "" });
  const [filtroModulo, setFiltroModulo] = useState("TODOS");
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState({ text: "", type: "" });

  useEffect(() => {
    cargarDatosSubMenus();
  }, []);

  const cargarDatosSubMenus = async () => {
    setCargando(true);
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const [resMod, resSub] = await Promise.all([
        fetch(`${API_URL}/api/usuarios/modulos`),
        fetch(`${API_URL}/api/usuarios/sub-formularios`)
      ]);
      const dataMod = await resMod.json();
      const dataSub = await resSub.json();

      if (dataMod.success) setListaModulosBD(dataMod.modulos || dataMod.data || []);
      if (dataSub.success) setListaSubMenus(dataSub.data || []);
    } catch (err) {
      setMensaje({ text: "Error cargando estructura de menús.", type: "error" });
    } finally {
      setCargando(false);
    }
  };

  const handleCrearSubMenu = async (e) => {
    e.preventDefault();
    if (!nuevoSubMenu.modulo_id || !nuevoSubMenu.nombre.trim()) return;
    setMensaje({ text: "", type: "" });

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/sub-formularios`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(nuevoSubMenu)
      });
      const data = await res.json();
      if (data.success) {
        setMensaje({ text: "¡Tarjeta / Submódulo creado con éxito! ✅", type: "success" });
        setNuevoSubMenu({ modulo_id: "", nombre: "" });
        cargarDatosSubMenus();
      } else {
        setMensaje({ text: data.message || "Error al crear submódulo.", type: "error" });
      }
    } catch (err) {
      setMensaje({ text: "Error de conexión con el servidor.", type: "error" });
    }
  };

  const handleEliminarSubMenu = async (id) => {
    if (!window.confirm("¿Estás seguro de eliminar esta tarjeta del menú?")) return;
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/sub-formularios/${id}`, {
        method: "DELETE"
      });
      const data = await res.json();
      if (data.success) {
        setMensaje({ text: "Tarjeta eliminada correctamente.", type: "success" });
        cargarDatosSubMenus();
      }
    } catch (err) {
      setMensaje({ text: "Error al eliminar la tarjeta.", type: "error" });
    }
  };

  const subMenusFiltrados = filtroModulo === "TODOS"
    ? listaSubMenus
    : listaSubMenus.filter(s => String(s.modulo_id) === String(filtroModulo));

  return (
    <div className="w-full flex flex-col lg:flex-row gap-8 animate-fade-in">
      {/* IZQUIERDA: Crear Nueva Tarjeta */}
      <div className="w-full lg:w-1/3 flex flex-col gap-6">
        <form onSubmit={handleCrearSubMenu} className="bg-slate-50/80 p-6 rounded-3xl border border-slate-200/80 shadow-sm space-y-4">
          <h3 className="text-xs font-black text-slate-400 uppercase tracking-widest">➕ Agregar Tarjeta o Submódulo</h3>
          
          <div>
            <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest mb-2">Módulo Padre</label>
            <select
              value={nuevoSubMenu.modulo_id}
              onChange={(e) => setNuevoSubMenu({ ...nuevoSubMenu, modulo_id: e.target.value })}
              required
              className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-xs font-bold text-slate-800 focus:outline-none focus:border-emerald-500 cursor-pointer shadow-sm"
            >
              <option value="">Selecciona el Módulo Padre...</option>
              {listaModulosBD.map(m => (
                <option key={m.id} value={m.id}>
                  {m.icono || "📁"} {m.label || m.description || m.name} (ID: {m.id})
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest mb-2">Nombre de la Tarjeta / Sub-formulario</label>
            <input
              type="text"
              placeholder="Ej: Manuales de Cargo..."
              value={nuevoSubMenu.nombre}
              onChange={(e) => setNuevoSubMenu({ ...nuevoSubMenu, nombre: e.target.value })}
              required
              className="w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-xs font-bold text-slate-800 focus:outline-none focus:border-emerald-500 shadow-sm"
            />
          </div>

          <button
            type="submit"
            className="w-full py-3.5 rounded-2xl bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white font-black text-xs uppercase tracking-widest shadow-lg shadow-emerald-500/25 transition cursor-pointer"
          >
            Guardar Tarjeta en BD
          </button>
        </form>
      </div>

      {/* DERECHA: Tabla de Submódulos */}
      <div className="w-full lg:w-2/3 bg-white/70 backdrop-blur-xl p-8 rounded-[32px] border border-white shadow-xl flex flex-col">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
          <div>
            <h3 className="text-xs font-black text-slate-400 uppercase tracking-widest">📋 Submódulos Registrados ({subMenusFiltrados.length})</h3>
          </div>
          <select
            value={filtroModulo}
            onChange={(e) => setFiltroModulo(e.target.value)}
            className="px-4 py-2 bg-slate-100 border border-slate-200 rounded-xl text-xs font-bold text-slate-700 focus:outline-none cursor-pointer"
          >
            <option value="TODOS">Todos los módulos</option>
            {listaModulosBD.map(m => (
              <option key={m.id} value={m.id}>{m.label || m.name}</option>
            ))}
          </select>
        </div>

        {mensaje.text && (
          <div className={`mb-6 p-4 rounded-2xl text-xs font-bold flex items-center gap-3 ${mensaje.type === "success" ? "bg-emerald-50 text-emerald-800 border border-emerald-200" : "bg-rose-50 text-rose-800 border border-rose-200"}`}>
            <span>{mensaje.type === "success" ? "✅" : "⚠️"}</span> {mensaje.text}
          </div>
        )}

        <div className="border border-slate-200/80 rounded-2xl overflow-hidden max-h-[420px] overflow-y-auto shadow-inner bg-white/50">
          <table className="w-full text-left text-xs text-slate-700">
            <thead className="bg-slate-100/90 text-slate-800 font-black uppercase text-[10px] tracking-wider border-b border-slate-200 sticky top-0">
              <tr>
                <th className="p-4">Módulo Padre</th>
                <th className="p-4">Nombre de la Tarjeta</th>
                <th className="p-4 text-center">Acción</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200/60">
              {cargando ? (
                <tr><td colSpan={3} className="p-8 text-center font-bold text-slate-400">Cargando submódulos...</td></tr>
              ) : subMenusFiltrados.length > 0 ? (
                subMenusFiltrados.map((sub) => (
                  <tr key={sub.id} className="hover:bg-slate-50/80 transition">
                    <td className="p-4 font-extrabold text-emerald-700 uppercase">{sub.modulo_nombre || `Módulo ID ${sub.modulo_id}`}</td>
                    <td className="p-4 font-bold text-slate-900">{sub.nombre}</td>
                    <td className="p-4 text-center">
                      <button
                        type="button"
                        onClick={() => handleEliminarSubMenu(sub.id)}
                        className="px-3 py-1.5 bg-rose-50 hover:bg-rose-600 text-rose-600 hover:text-white rounded-xl font-black text-[10px] uppercase tracking-wider transition border border-rose-200 cursor-pointer"
                      >
                        🗑 Eliminar
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan={3} className="p-8 text-center text-slate-400 italic font-semibold">No hay tarjetas registradas para este filtro.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}